import React from 'react';
import PropTypes from 'prop-types';

import Img from '../../../Img';
import BackgroundImage from '../../../BackgroundImage';
import config from '../../../../../config';

import styles from './avatarV2.scss';

const AvatarV2 = props => {
    const { playerImages, nationality, player, className, 'data-testid': dataTestId } = props;
    const nationalFlag = nationality ? `/img/flags/${nationality.toLowerCase()}.svg` : '';
    const baseUrl = config.alwaysUseProxy ? '/api/v1/player/' : '/v1/player/';

    let images;
    if (playerImages?.default) {
        images = playerImages;
    } else if (player.playerProfileImages?.default) {
        images = player.playerProfileImages;
    }

    return (
        <div className="avatar-wrapper" data-testid={dataTestId}>
            {images ? (
                <BackgroundImage
                    baseUrl={baseUrl}
                    defaultImage={'/img/v2/icons/icon-avatar-player.svg'}
                    images={images}
                    imageType={'icon'}
                    extraCls={'playerIconImage'}
                    parentStylesClass={`avatar d-inline-block ${className}`}
                />
            ) : (
                <div className={`${styles.placeholder} ${className}`}>{player.firstName?.[0]}{player.lastName?.[0]}</div>
            )}
            {nationalFlag && <Img className="flag" src={nationalFlag} alt={nationality} />}
        </div>
    );
};

AvatarV2.propTypes = {
    playerImages: PropTypes.shape({
        default: PropTypes.string,
        icon: PropTypes.shape({
            oneX: PropTypes.string,
            twoX: PropTypes.string,
            threeX: PropTypes.string,
        }),
        thumbnail: PropTypes.shape({
            oneX: PropTypes.string,
            twoX: PropTypes.string,
            threeX: PropTypes.string,
        }),
    }),
    nationality: PropTypes.string,
    player: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        playerProfileImages: PropTypes.shape({
            default: PropTypes.string,
            icon: PropTypes.shape({
                oneX: PropTypes.string,
                twoX: PropTypes.string,
                threeX: PropTypes.string,
            }),
            thumbnail: PropTypes.shape({
                oneX: PropTypes.string,
                twoX: PropTypes.string,
                threeX: PropTypes.string,
            }),
        }),
    }).isRequired,
    className: PropTypes.string,
    'data-testid': PropTypes.string,
};
AvatarV2.defaultProps = {
    playerImages: null,
    className: '',
    nationality: '',
    'data-testid': undefined,
};

export default AvatarV2;
